import React from "react";
import styled, { keyframes } from "styled-components";

// Indicador de carga circular con la misma geometría y animación que el CircularProgress de Material UI.
const rotate = keyframes`
  100% { transform: rotate(360deg); }
`;

const dash = keyframes`
  0% { stroke-dasharray: 1px, 200px; stroke-dashoffset: 0; }
  50% { stroke-dasharray: 100px, 200px; stroke-dashoffset: -15px; }
  100% { stroke-dasharray: 100px, 200px; stroke-dashoffset: -125px; }
`;

const Svg = styled.svg`
  display: inline-block;
  width: 40px;
  height: 40px;
  animation: ${rotate} 1.4s linear infinite;
  circle {
    stroke: currentColor;
    stroke-dasharray: 80px, 200px;
    stroke-dashoffset: 0;
    animation: ${dash} 1.4s ease-in-out infinite;
  }
`;

const Spinner = ({ color = "white", label = "Cargando" }) => (
  <Svg viewBox="22 22 44 44" role="progressbar" aria-label={label} style={{ color }}>
    <circle cx="44" cy="44" r="20.2" fill="none" strokeWidth="3.6" />
  </Svg>
);

export default Spinner;
